<template>
  <!-- 展会基础信息 -->
  <div class="exInfo">
    <div class="exInfo-content">
      <Form
        ref="formValidate"
        :model="formInline"
        :rules="ruleInline"
        :label-width="130"
        style="width: 700px"
      >
        <FormItem label="展会Id：">
          <Input v-model="exhibitionInfo.id" disabled />
        </FormItem>
        <FormItem label="展会名称：" prop="name">
          <Input v-model="formInline.name" placeholder="请输入展会名称" />
        </FormItem>
        <FormItem label="展会简称：" prop="shortName">
          <Input v-model="formInline.shortName" placeholder="请输入展会简称" />
        </FormItem>
        <FormItem label="英文名称：" prop="enName">
          <Input v-model="formInline.enName" placeholder="请输入展会英文名称" />
        </FormItem>
        <!-- <FormItem label="编号前缀：" >
          <Input v-model="formInline.CodeTemplate" placeholder="请输入编号前缀" />
        </FormItem> -->
        <!-- <FormItem label="当前编号: " >
          <Input v-model="formInline.CodeNum" placeholder="请输入当前编号" />
        </FormItem> -->
        <FormItem label="展会Logo：" prop="actImg">
          <div class="my-upload">
            <div
              class="my-upload-list"
              v-for="(item, index) in uploadList"
              :key="'upload' + index"
            >
              <template v-if="item.status === 'finished'">
                <img :src="item.url" style="width: 100px; height: 100px" />
                <div class="my-upload-list-cover">
                  <Icon
                    type="ios-eye-outline"
                    @click.native="handleView(item.url)"
                  ></Icon>
                  <Icon
                    type="ios-trash-outline"
                    @click.native.stop.prevent="handleRemove(item)"
                  ></Icon>
                </div>
              </template>
              <template v-else>
                <Spin
                  v-if="item.showProgress"
                  style="width: 100px; height: 100px"
                >
                  <Icon
                    type="ios-loading"
                    size="20"
                    class="demo-spin-icon-load"
                  ></Icon>
                </Spin>
              </template>
            </div>
            <Upload
              ref="upload"
              :show-upload-list="false"
              :default-file-list="defaultList"
              :on-success="handleSuccess"
              :format="['jpg', 'jpeg', 'png']"
              :max-size="2048"
              :headers="formHeaders"
              :on-format-error="handleFormatError"
              :on-exceeded-size="handleMaxSize"
              :before-upload="handleBeforeUpload"
              multiple
              type="drag"
              :action="uploadUrl"
              style="display: inline-block"
              v-show="uploadList && uploadList.length < 1"
            >
              <div
                style="
                  width: 100px;
                  height: 100px;
                  padding-top: 18px;
                  color: rgb(133, 133, 133);
                "
              >
                <div style="font-size: 25px">
                  +
                  <p style="font-size: 14px">上传图片</p>
                </div>
              </div>
            </Upload>
            <iModal title="图片查看" cancel-text v-model="visible">
              <div style="text-align: center">
                <img :src="imgName" v-if="visible" style="max-width: 100%" />
              </div>
            </iModal>
          </div>
          <p class="upload-p" style="display: block; font-size: 12px">
            (图片要求：2M以下的jpg或png，建议尺寸200*200px)
          </p>
        </FormItem>
        <FormItem label="举办时间：" prop="hostdate">
          <DatePicker
            type="datetimerange"
            format="yyyy-MM-dd"
            placeholder="请选择举办时间"
            style="width: 350px"
            v-model="hostdate"
            @on-change="dateChange"
          ></DatePicker>
        </FormItem>
        <FormItem label="举办城市：">
          <Row type="flex" justify="space-between">
            <Col span="11">
              <FormItem>
                <Select
                  v-model="formInline.province"
                  placeholder="请选择省份"
                  @on-change="changeProvince"
                >
                  <Option
                    v-for="(item, index) in provinceArr"
                    :key="item.value"
                    :value="item.value"
                    >{{ item.label }}</Option
                  >
                </Select>
              </FormItem>
            </Col>
            <Col span="11">
              <FormItem>
                <Select
                  v-model="formInline.city"
                  placeholder="请选择城市"
                  @on-change="changeCity"
                >
                  <Option
                    v-for="(item, index) in citiesArr"
                    :key="item.value"
                    :value="item.value"
                    >{{ item.label }}</Option
                  >
                </Select>
              </FormItem>
            </Col>
          </Row>
        </FormItem>
        <FormItem label="举办地址：">
          <Input
            v-model="formInline.address"
            placeholder="请输入展会举办地址"
          />
        </FormItem>
        <!-- <FormItem label="举办地址坐标：">
          <Input v-model="formInline.site" placeholder="请输入地址坐标" />
          <a
            href="https://lbs.qq.com/tool/getpoint/index.html"
            target="_blank"
            style="
              position: absolute;
              right: -80px;
              top: 0;
              color: #108ee9;
              font-size: 14px;
            "
          >
            坐标拾取器
          </a>
        </FormItem> -->
        <FormItem label="举办场馆：">
          <Input v-model="formInline.venue" placeholder="请输入展会举办场馆" />
        </FormItem>
        <!-- <FormItem label="举办场馆(英文)：">
          <Input
            v-model="formInline.venueEn"
            placeholder="请输入展会举办场馆(英文名)"
          />
        </FormItem> -->
        <!-- <FormItem label="展位号显示状态：">
           <Checkbox v-model="formInline.IsShowBoothInfo">是否显示</Checkbox>
        </FormItem> -->
        <FormItem label="展会排序：">
          <InputNumber :max="30" :min="1" v-model="formInline.showIndex"></InputNumber>
        </FormItem>
        <FormItem label="报名显示顺序：">
          <InputNumber  :min="0" v-model="formInline.SignIndex"></InputNumber>
        </FormItem>
        <FormItem label="展会简介：" v-if="false">
          <!-- <RadioGroup v-model="intType">
            <Radio label="0">文本</Radio>
            <Radio label="1">纯图</Radio>
          </RadioGroup> -->
          <customComponentCommon
            v-model="formInline.introduction"
            :type="2"
            @change="changModal"
          ></customComponentCommon>
        </FormItem>
        <!-- <FormItem v-show="intType === '0'">
          <Input v-model="formInline.introduction" type="textarea" :rows="4" />
        </FormItem>
        <FormItem v-show="intType === '1'">
          <div class="my-upload">
            <div
              class="my-upload-list"
              v-for="(item, index) in uploadList2"
              :key="'upload2' + index"
            >
              <template v-if="item.status === 'finished'">
                <img :src="item.url" style="width: 100px;height: 100px;" />
                <div class="my-upload-list-cover">
                  <Icon type="ios-eye-outline" @click.native="handleView2(item.url)"></Icon>
                  <Icon type="ios-trash-outline" @click.native.stop.prevent="handleRemove2(item)"></Icon>
                </div>
              </template>
              <template v-else>
                <Spin v-if="item.showProgress" style="width: 100px;height: 100px;">
                  <Icon type="ios-loading" size=20 class="demo-spin-icon-load"></Icon>
                </Spin>
              </template>
            </div>
            <Upload
              ref="upload2"
              :show-upload-list="false"
              :default-file-list="defaultList2"
              :on-success="handleSuccess2"
              :format="['jpg','jpeg','png']"
              :max-size="2048"
              :headers="formHeaders"
              :on-format-error="handleFormatError"
              :on-exceeded-size="handleMaxSize"
              :before-upload="handleBeforeUpload2"
              multiple
              type="drag"
              :action="uploadUrl"
              style="display: inline-block;"
              v-show="uploadList2 && uploadList2.length < 15"
            >
              <div style="width:100px;height:100px;padding-top: 18px;color:rgb(133, 133, 133)">
                <div style="font-size:25px">
                  +
                  <p style="font-size:14px">上传图片</p>
                </div>
              </div>
            </Upload>
            <iModal title="图片查看" cancel-text v-model="visible2">
              <div style="text-align: center;">
                <img :src="imgName2" v-if="visible2" style="max-width: 100%" />
              </div>
            </iModal>
          </div>
          <p class="upload-p" style="display:block;font-size:12px;">(图片要求：2M以下的jpg或png)</p>
        </FormItem> -->
      </Form>
      <div style="padding: 40px 0 0 120px">
        <Button
          style="width: 82px; height: 32px"
          type="primary"
          :loading="loading"
          @click="handleSubmit('formValidate')"
          >保存</Button
        >
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { provinces } from "@/other/provinces";
import customComponentCommon from "@components/custom-component/custom-component-common.vue";

export default {
  name: "host-exInfo",
  data() {
    const that = this;
    const actImgReg = (rule, value, callback) => {
      if (that.uploadList && that.uploadList.length) {
        callback();
      } else {
        callback(new Error("请上传展会Logo"));
      }
    };
    const hostDateReg = (rule, value, callback) => {
      if (that.hostdate && that.hostdate.length > 0) {
        callback();
      } else {
        callback(new Error("请选择举办时间"));
      }
    };
    return {
      formInline: {
        name: "", // 展会名称
        shortName: "", // 展会简称
        enName: "", // 英文名称
        province: "", // 省
        city: "", // 市
        address: "", // 举办地址
        site: "", // 坐标
        venue: "", // 场馆
        venueEn: "",
        introduction: [],
        CodeTemplate:"",
        CodeNum:'',
        IsShowBoothInfo:"",
        showIndex:0,
        SignIndex:0,
      },
      ruleInline: {
        name: [{ required: true, message: "请输入展会名称", trigger: "blur" }],
        shortName: [
          { required: true, message: "请输入展会简称", trigger: "blur" },
        ],
        enName: [
          { required: true, message: "请输入英文名称", trigger: "blur" },
        ],
        address: [
          { required: true, message: "请输入展会举办地址", trigger: "blur" },
        ],
        site: [{ required: true, message: "请输入地址坐标", trigger: "blur" }],
        venue: [
          { required: true, message: "请输入展会举办场馆", trigger: "blur" },
        ],
        province: [
          {
            required: true,
            message: "请选择举办省份",
            trigger: "change",
          },
        ],
        city: [
          { required: true, message: "请选择举办城市", trigger: "change" },
        ],
        address: [
          { required: true, message: "请输入举办地址", trigger: "blur" },
        ],
        actImg: [{ required: true, validator: actImgReg, trigger: "blur" }],
        hostdate: [
          { required: true, validator: hostDateReg, trigger: "change" },
        ],
      },
      uploadList: [], // 展会logo
      defaultList: [],
      imgName: "",
      visible: false,
      hostDate: [], // 举办时间
      hostdate: [],
      provinceArr: [],
      citiesArr: [],
      intType: "0", // 0文本 1纯图
      uploadList2: [],
      defaultList2: [],
      imgName2: "",
      visible2: false,
      loading: false,
      exhibitionId: '',
    };
  },
  computed: {
    ...mapGetters({
      uploadUrl: "getUploadUrl",
      formHeaders: "getFormHeaders",
    }),
    exhibitionInfo() {
      if (JSON.parse(localStorage.vuex)) {
        return JSON.parse(localStorage.vuex).hostSetModule.hostExhibition;
      }
    },
  },
  async created() {
    // this.provinceArr = provinces.data;
         let list = await this.getAllAddress()
     if (list[0] && list[0].name === "中国") {
        // 调用转换函数
         const transformedData =await this.regular.transformData(list[0]);
         this.provinceArr = transformedData.children;
            }
    this.init();
  },
  methods: {
    ...mapActions({
       getAllAddress:"getAllAddress",
      getExhibitionById: "hostSetModule/getExhibitionById",
      editExhibition: "hostSetModule/editExhibition",
      transformCustomData: "customComponentModule/transformCustomData",
      transformReqCustomData: "customComponentModule/transformReqCustomData",
    }),
    async init() {
      let result = await this.getExhibitionById(this.exhibitionInfo.id);
      console.log(result);
      if (result) {
        this.formInline.name = result.name;
        this.formInline.shortName = result.shortName;
        this.formInline.enName = result.nameEn;
        this.formInline.CodeTemplate=result.codeTemplate;
        this.formInline.showIndex=result.showIndex
        this.formInline.SignIndex=result.SignIndex?result.SignIndex:0
        if(result.isShowBoothInfo==0){
          this.formInline.IsShowBoothInfo=false
        }
        else{
          this.formInline.IsShowBoothInfo=true
        }
        this.uploadList = [
          {
            status: "finished",
            percentage: 100,
            url: result.logo,
          },
        ];
        if (result.startTime && result.endTime) {
          this.hostdate = [result.startTime, result.endTime];
          this.hostDate = [result.startTime, result.endTime];
        }
        if (result.province) {
          this.formInline.province = result.province;
          for (var i = 0; i < this.provinceArr.length; i++) {
            if (this.formInline.province == this.provinceArr[i].value) {
              this.citiesArr = this.provinceArr[i].children;
            }
          }
        }
        if (result.city) {
          this.formInline.city = result.city;
        }
        this.formInline.address = result.address;
        this.formInline.site = result.coordinate;
        this.formInline.venue = result.exHall;
        this.formInline.venueEn = result.exHallEn;
        
        if (result.introduction && result.introduction.indexOf("[") !== -1) {
          this.formInline.introduction = await this.transformCustomData(
            JSON.parse(result.introduction)
          );
        }
      }
    },
    async handleSubmit(name) {
      let valid = await this.validForm(name);
      if (!valid) return;
      let startTime = "";
      let endTime = "";
      if (!this.hostDate[0] || !this.hostDate[1]) {
        this.$Message.warning("请选择举办时间");
        return;
      } else {
        startTime = this.hostDate[0];
        endTime = this.hostDate[1];
      }
      // let introduction = null;
      // if (this.intType == '0') {
      //   this.uploadList2 = [];
      //   this.$refs.upload2.fileList = [];
      //   introduction = this.formInline.introduction;
      // }
      // if (this.intType == '1') {
      //   this.formInline.introduction = "";
      //   introduction  = this.transfromImgList(this.uploadList2);
      // }

      // 简介
      let Introduction = await this.transformReqCustomData(
        this.formInline.introduction
      );
      if (!Introduction || Introduction === "[]") {
        this.$Message.error("请完善简介信息");
        return;
      }
      let IsShowBoothInfo=false
      if(this.formInline.IsShowBoothInfo==false){
        IsShowBoothInfo=0
      }
      else{
        IsShowBoothInfo=1
      }
      let req = {
        Id: this.exhibitionInfo.id,
        SetValues: {
          Name: this.formInline.name,
          ShortName: this.formInline.shortName,
          NameEn: this.formInline.enName,
          Logo: this.uploadList[0].url,
          StartTime: startTime,
          EndTime: endTime,
          Province: this.formInline.province,
          City: this.formInline.city,
          Address: this.formInline.address,
          Introduction: Introduction,
          Coordinate: this.formInline.site,
          ExHall: this.formInline.venue,
          ExHallEn: this.formInline.venueEn,
          CodeTemplate:this.formInline.CodeTemplate,
          ShowIndex:this.formInline.showIndex,
          SignIndex:this.formInline.SignIndex,
          IsShowBoothInfo:IsShowBoothInfo
          //CodeNum:this.formInline.CodeNum
        },
      };
      this.loading = true;
      let bool = await this.editExhibition(req);
      if (bool && bool.successed) {
        this.$Message.success("保存成功");
        this.loading = false;
        this.init();
      } else {
        this.$Message.error("保存失败，请重新尝试");
        this.loading = false;
      }
    },
    transform(arr) {
      let arr2 = [];
      arr.map((itm, idx) => {
        arr2.push({
          status: "finished",
          percentage: 100,
          url: itm,
        });
      });
      return arr2;
    },
    transfromImgList(arr) {
      let arr2 = [];
      arr.forEach((c) => {
        arr2.push(c.url);
      });
      return arr2;
    },
    // 验证表单
    validForm(name) {
      return new Promise((resolve, reject) => {
        this.$refs[name].validate((valid) => {
          resolve(valid);
        });
      });
    },
    // 上传成功
    handleSuccess(res, file) {
      if (res && res.list.length) {
        file.url = res.list[0];
        this.uploadList = this.$refs.upload.fileList;
      }
    },
    handleSuccess2(res, file) {
      if (res && res.list.length) {
        file.url = res.list[0];
        this.uploadList2 = this.$refs.upload2.fileList;
      }
    },
    // 文件格式错误
    handleFormatError(file) {
      this.$Message.warning(`文件格式是不正确的, 请上传jpg或者png格式的图片`);
    },
    // 文件过大
    handleMaxSize(file) {
      this.$Message.warning(`文件大小超过限制, 请上传小于2M的图片`);
    },
    // 上传数量
    handleBeforeUpload() {
      const limitNum = 1;
      const check = this.uploadList.length < limitNum;
      if (!check) {
        this.$Message.warning(`最多上传${limitNum}张图片`);
      }
      return check;
    },
    handleBeforeUpload2() {
      const limitNum = 15;
      const check = this.uploadList2.length < limitNum;
      if (!check) {
        this.$Message.warning(`最多上传${limitNum}张图片`);
      }
      return check;
    },
    // 查看上传图片
    handleView(name) {
      this.imgName = name;
      this.visible = true;
    },
    handleView2(name) {
      this.imgName2 = name;
      this.visible2 = true;
    },
    // 移除上传图片
    handleRemove(file) {
      const fileList = this.uploadList;
      this.uploadList.splice(fileList.indexOf(file), 1);
    },
    handleRemove2(file) {
      const fileList = this.uploadList2;
      this.uploadList2.splice(fileList.indexOf(file), 1);
    },
    changeProvince(val) {
      for (var i = 0; i < this.provinceArr.length; i++) {
        if (val == this.provinceArr[i].value) {
          this.citiesArr = this.provinceArr[i].children;
        }
      }
    },
    changeCity(val) {
      // for (var i = 0; i < this.citiesArr.length; i++) {
      //   if (val == this.citiesArr[i].value) {
      //     this.countyArr = this.citiesArr[i].children;
      //   }
      // }
    },
    dateChange(e) {
      this.hostDate = e;
    },
    changModal($event) {
      this.formInline.introduction = $event;
    },
  },
  components: {
    customComponentCommon,
  },
};
</script>

<style scoped lang="scss">
.exInfo {
  background-color: #fff;
  min-width: 800px;
  padding: 40px 70px 200px 70px;
  margin: 30px;
}
</style>
